<template>
<div class="custom d-inline">
	<v-text-field
		:disabled="disabledValue"
		:label="label"
		:prepend-icon="$vuetify.rtl ? 'mdi-menu-right' : 'mdi-menu-left'"
		:append-outer-icon="$vuetify.rtl ? 'mdi-menu-left' : 'mdi-menu-right'"
		v-model="localValue"
		outlined
		dense
		type="date"
		@click:prepend="up()"
		@click:append-outer="down()"
		@blur="$emit('blur')"
		:rules="rules"
		@keydown.enter.prevent="$emit('keydown-enter-prevent')"
		@keydown.esc.prevent="$emit('keydown-esc-prevent')"
		:hide-details="(!!hideDetails) ? 'hide' : false"
		style=" font-family: Calibri !important; font-weight: 550 !important; font-size: 1.05rem !important;"
	></v-text-field>
</div>
</template>
<script>
import baseBeeComponent from "../../baseBeeComponent";
import { format, addDays, parseISO } from "date-fns";
export default {
mixins: [baseBeeComponent],
props:["rules", "value", "label", "hideDetails"],
name: "BeeDatePicker",
methods: {
	up() {
		this.localValue = addDays(parseISO(this.localValue), -0.5).toISOString().substr(0, 10)
	},
	down() {
		this.localValue = addDays(parseISO(this.localValue), 2).toISOString().substr(0, 10)
	},
	changeFormat(value){
		if(this.value == null) {	
			this.$emit('input',format(parseISO(new Date().toISOString().substr(0, 10)), 'yyyy-MM-dd'))
		} 
		else {
			this.$emit('input',format(parseISO(new Date(value).toISOString().substr(0, 10)), 'yyyy-MM-dd'))
		}
	}
},
watch: {
	value(to) {
		if(to == null) this.localValue = new Date().toISOString()
	}
},
mounted(){
	this.changeFormat(this.value)
},
computed:{
	localValue: {
		get: function() {
			return this.value
		},
		set: function(value) {
			this.changeFormat(value)
		}
	}
},
};
</script>
<style>
.v-application--is-rtl .v-input__append-outer {
  margin-right: 4px !important;
}
.v-application--is-rtl .v-input__prepend-outer {
  margin-left: 4px !important;
}
.custom input{
    caret-color: auto !important;
    font-family: Calibri !important;
    font-weight: 550 !important;
    font-size: 1.05rem !important;
}
</style>
